<template>
    <svg height="6px" viewBox="0 0 10 6" width="10px" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1">
            <path
                d="M1,1.00635613 C1,1.00635613 5,4.62635613 5,4.62635613 C5,4.62635613 6.33333333,3.41968946 9,1.00635613"
                stroke="currentColor"
            ></path>
        </g>
    </svg>
</template>
